export default function EmptyBox({label}) {
  return <div className="empty-box">{label || "Мэдээлэл байхгүй байна"}</div>
}
